/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class Oauth2TokenResponse {
  /**
  * Access token, which you pass in the `Authorization` header when calling API methods.
  */
  'accessToken'?: string;
  /**
  * Type of the token, which is always `Bearer`.
  */
  'tokenType'?: string;
  /**
  * Token used to obtain a new access token when the current one expires. 
  */
  'refreshToken'?: string;
  /**
  * Length of time until the token expires, in seconds. Default: `43200` (12 hours). 
  */
  'expiresIn'?: number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "accessToken",
      "baseName": "access_token",
      "type": "string",
      "format": ""
    },
    {
      "name": "tokenType",
      "baseName": "token_type",
      "type": "string",
      "format": ""
    },
    {
      "name": "refreshToken",
      "baseName": "refresh_token",
      "type": "string",
      "format": ""
    },
    {
      "name": "expiresIn",
      "baseName": "expires_in",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return Oauth2TokenResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

